import React, { useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import SwiperCore, {
  Navigation,
  Pagination,
  Autoplay,
  FreeMode,
  Thumbs,
  EffectFade,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import * as apiUrl from "../../apiUrl";

SwiperCore.use([FreeMode, Navigation, Thumbs, Autoplay, EffectFade]);

function CollectionInnerLivingSpace({ living }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const mainSwiperRef = useRef(null); // For main Swiper
  const [activeIndex, setActiveIndex] = useState(0); // Track active slide index

  const livingSlides = living.slides ? JSON.parse(living.slides) : [];

  return (
    <section className="collection-inner-livingspace-sec">
      <Container fluid>
        <Row className="banner-text-center">
          <Col md={12}>
            <div className="heading-div">
              <h2 className="common-head darkGrey" data-aos="fade-up">
                {living.title}
              </h2>
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid className="livingspace-container">
        <Row className="flex-center">
          <Col md={12}>

            <div className="living-space-swiper-div">
              <Swiper
                navigation={true}
                modules={[EffectFade, Navigation]}
                spaceBetween={10}
                slidesPerView={1}
                speed={1000}
                autoplay={true}
                grabCursor={true}
                draggable={true}
                loop={true}
              >
                {livingSlides.map((livingSlide, index) => (
                  <SwiperSlide key={index}>
                    <div className="living-space-swiper-row">
                      <Row>
                        <Col md={6}>
                          <div className="living-space-content-div">

                            <h2 className="common-head goldenColor">
                              {livingSlide.title}
                            </h2>
                            <p>{livingSlide.description}</p>
                          </div>
                        </Col>
                        <Col md={6} className="card-bg-img">
                          <div className="living-space-img card-img">
                            <img
                              src={`${apiUrl.apiUrl}/${livingSlide.image}`}
                              className="img-fluid" alt="Luxury real estate Developer Dubai"
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </SwiperSlide>
                ))}

              </Swiper>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default CollectionInnerLivingSpace;
